// extracted by mini-css-extract-plugin
export default {"carStatistics":"carStatistics_carStatistics__kCS3M","carStatisticsWithDetails":"carStatistics_carStatisticsWithDetails__L97iq"};